import { httpClient, setResponseType, removeResponseType } from '@/app/shared/services';
import { apiConstants } from '../config';

const URL = apiConstants.client;
const URL_PANEL = apiConstants.clientsPanel;
const CLIENT_URL = apiConstants.client;
const GROUPS_URL = apiConstants.group;


const fetchAllClients = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${URL_PANEL}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${URL_PANEL}?${filter}`).then(res => res.data)
  }
};

const fetchOneClient = (clientId) => {
  return httpClient.get(`${URL}/${clientId}`).then(res => res.data);
};

const updateClient = (clientToEdit) => {
  // console.log(clientToEdit);
  // clientToEdit.dni = '56138521Y'; // TODO: eliminar require dni de api
  return httpClient.put(`${URL}/${clientToEdit.id}`, clientToEdit).then(res => res.data);
};

const deleteClient = (clientId) => {
  return httpClient.delete(`${URL}/${clientId}`).then(res => res);
};

const downloadExcel = (filename) => {
  setResponseType('blob'); // arraybuffer
  return httpClient.post(`${URL_PANEL}/to-excel`, {name: filename}).then(res => {
    setResponseType('json');
    return res
  });
};

const resetResponseType = () => {
  setResponseType('json');
};

const fetchCreditCardAboutToExpired = (page = null) => {
  const URL = `${apiConstants.dashboard}/about-to-expire-credit-cards`;

  if (page != null) {
    return httpClient.get(`${URL_PANEL}?page=${page}`).then(res => res.data)
  }
  else {
    return httpClient.get(URL_PANEL).then(res => res.data)
  }
};

const fetchCreditCardExpired = (page = null) => {
  const URL = `${apiConstants.dashboard}/expired-credit-cards`;

  if (page != null) {
    return httpClient.get(`${URL_PANEL}?page=${page}`).then(res => res.data)
  }
  else {
    return httpClient.get(URL_PANEL).then(res => res.data)
  }
};


const addGroupClient = (groups_id, clients_id ) => {
  return httpClient.post(`${URL_PANEL}/set-group`, {clients_id, groups_id}).then(res => res.data);
};

const deleteGroupClient = (clients_id ) => {
  return httpClient.post(`${URL_PANEL}/set-group`, { clients_id }).then(res => res.data);
};

// Route::post('clients/add-new-credit-card/{id}'
// data.URL_REDIRECT
const newCardClient = (clients_id ) => {
  return httpClient.post(`${URL}/add-new-credit-card/${clients_id}`, {}).then(res => res.data);
};

const editCreditCard = () => {
  setResponseType('text')
  return httpClient.post(URL + '/update-card', {}, { responseType: 'text' })
    .then((htmlForm) => {
      setResponseType('json');
      return htmlForm;
    });
};

const getCurrentClient = () => {
  return httpClient.get(URL + '/me').then((resp) => resp.data);
};

const editCurrentClient = (data) => {
  return httpClient.put(URL + '/me', data).then((resp) => resp);
};

const editBillingInfo = (data) => {
  return httpClient.put(URL + '/billing', data).then((resp) => resp);
};

export {
  fetchAllClients,
  fetchOneClient,
  updateClient,
  deleteClient,
  downloadExcel,
  resetResponseType,
  fetchCreditCardAboutToExpired,
  fetchCreditCardExpired,
  addGroupClient,
  deleteGroupClient,
  newCardClient,
};


/*

PASARELA TPV
[POST] clients/add-new-credit-card/{id_usuario}
eso seria el equivalente al form que en la v1 salia entre el paso 3  y el paso 4
te devuelve en este formato
object(stdClass)#561 (3) {
["DS_ERROR_ID"]=>
int(0)
["URL_REDIRECT"]=>
string(438)
"https://api.paycomet.com/gateway/ifr-bankstore?MERCHANT_MERCHANTCODE=du7ybfr6&MERCHANT_TERMINAL=26345&OPERATION=107&LANGUAGE=ES&MERCHANT_MERCHANTSIGNATURE=44f35c3faa3168905f8e78db82689dce2ea397f8ebe3d3bff1b9168da0fb8c6d5a2f0f3e4592031c9e0900b1442878f72184bc5e4f2d624fac91c001021a640a&MERCHANT_ORDER=RC_1&VHASH=3f4afbe9d24d6c48a2ab163f40b7670b2d0694c452f2198eabfc50e6f45bd804c802b52ca088a448e5ea89c4139ef182105139ca808bc0b8bdc54b345cb4dfa2"
["RESULT"]=>
string(2) "OK"
}




*/
